import './ImageLibrarySection.css';

import React from 'react';

const ImageLibrarySection = ({ children }: { children: React.ReactNode }) => (
  <div className="ImageLibrarySection">{children}</div>
);

export default ImageLibrarySection;
